import { Outlet, Route } from 'react-router-dom';
import PrivateRoute from '../../PrivateRoute/PrivateRoute';
import Physicians from '../Physicians/Physicians';
import PhysicianAdd from '../Physicians/PhysicianAdd/PhysicianAdd';
import Physician from '../Physicians/Physician/Physician';
import GiveAccess from '../Physicians/Physician/GiveAccess/GiveAccess';
import Pipeline from './Pipeline/Pipeline';
import PipelineReports from './Pipeline/PipelineReports/PipelineReports';
import PipelineCRM from './Pipeline/PipelineCRM/PipelineCRM';

export const HealthRouter = (
  <Route path="health" element={<Outlet />}>
    <Route
      index
      element={(
        <PrivateRoute roles={['Admin', 'Rep', 'Pharmacy']}>
          <Physicians health />
        </PrivateRoute>
      )}
    />

    <Route
      path="add"
      element={(
        <PrivateRoute roles={['Admin', 'Pharmacy']}>
          <PhysicianAdd health />
        </PrivateRoute>
      )}
    />

    <Route
      path=":healthId"
      element={(
        <PrivateRoute roles={['Admin', 'Rep', 'Pharmacy']}>
          <Physician type="health" />
        </PrivateRoute>
      )}
    />

    <Route
      path=":healthId/edit"
      element={(
        <PrivateRoute roles={['Admin', 'Pharmacy']}>
          <PhysicianAdd edit health />
        </PrivateRoute>
      )}
    />

    <Route
      path=":healthId/access"
      element={(
        <PrivateRoute roles={['Admin', 'Pharmacy']}>
          <GiveAccess health />
        </PrivateRoute>
          )}
    />

    <Route
      path="pipeline"
      element={(
        <PrivateRoute roles={['Health']}>
          <Pipeline />
        </PrivateRoute>
      )}
    />

    <Route
      path="pipeline-reports"
      element={(
        <PrivateRoute roles={['Health']}>
          <PipelineReports />
        </PrivateRoute>
      )}
    />

    <Route
      path="pipeline-crm"
      element={(
        <PrivateRoute roles={['Health']}>
          <PipelineCRM />
        </PrivateRoute>
      )}
    />
  </Route>
);
